import { render, staticRenderFns } from "./Startseite.vue?vue&type=template&id=a14f1d16&scoped=true&"
import script from "./Startseite.vue?vue&type=script&lang=js&"
export * from "./Startseite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a14f1d16",
  null
  
)

export default component.exports